import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_7 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { class: "dropdown" }
const _hoisted_10 = {
  key: 0,
  class: "dropdown-menu"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.auth.can('EXPORT_NEW_CUSTOMERS'))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newClientExport()))
            }, _cache[1] || (_cache[1] = [
              _createTextVNode(" Export ", -1),
              _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1)
            ])))
          : _createCommentVNode("", true)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
        _createElementVNode("input", {
          type: "text",
          class: "form-control shadow-none text-black rounded-0",
          placeholder: "Search "
        })
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_vue_good_table, {
        columns: _ctx.headers,
        rows: _ctx.rows
      }, {
        emptystate: _withCtx(() => [
          _createVNode(_component_center, null, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Aucune entrées correspondantes trouvées", -1)
            ])),
            _: 1,
            __: [3]
          })
        ]),
        "table-row": _withCtx((props) => [
          (props.column.field == 'created_at')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
            : (props.column.field === 'name')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("b", null, "Nom du magasin : ", -1)),
                  _createTextVNode(_toDisplayString(props.row.store), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("b", null, "Nom complet : ", -1)),
                  _createTextVNode(_toDisplayString(props.row.name), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("b", null, "Type d'entereprise : ", -1)),
                  _createTextVNode(_toDisplayString(props.row.company_type), 1),
                  _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                  _cache[10] || (_cache[10] = _createElementVNode("b", null, "CIN : ", -1)),
                  _createTextVNode(_toDisplayString(props.row.cin), 1),
                  _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("b", null, "Site web : ", -1)),
                  _createTextVNode(_toDisplayString(props.row.website), 1),
                  _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("b", null, "Registre de commerce : ", -1)),
                  _createTextVNode(" " + _toDisplayString(props.row.rc), 1)
                ]))
              : (props.column.field === 'address')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[15] || (_cache[15] = _createElementVNode("b", null, "Adresse électronique : ", -1)),
                    _createTextVNode(_toDisplayString(props.row.email), 1),
                    _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                    _cache[17] || (_cache[17] = _createElementVNode("b", null, "Mot de passe : ", -1)),
                    _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                    _cache[19] || (_cache[19] = _createElementVNode("b", null, "Numéro de téléphone : ", -1)),
                    _createTextVNode(_toDisplayString(_ctx.oldPhone(props.row.phone)), 1),
                    _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                    _cache[21] || (_cache[21] = _createElementVNode("b", null, "Ville : ", -1)),
                    _createTextVNode(_toDisplayString(props.row.city), 1),
                    _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                    _cache[23] || (_cache[23] = _createElementVNode("b", null, "Adresse : ", -1)),
                    _createTextVNode(" " + _toDisplayString(props.row.address), 1)
                  ]))
                : (props.column.field == 'action')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[27] || (_cache[27] = _createElementVNode("button", {
                          class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          _createElementVNode("i", { class: "flaticon-dots" })
                        ], -1)),
                        (_ctx.auth.can('NEW_CUSTOMERS'))
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                              _createElementVNode("li", null, [
                                (_ctx.auth.can('NEW_CUSTOMERS') && props.row.statut==0)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: `/edit-new-customer/` + props.row.id,
                                      class: "dropdown-item d-flex align-items-center",
                                      href: "javascript:void(0);"
                                    }, {
                                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                                        _createElementVNode("i", { class: "flaticon-plus lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Modifier ", -1)
                                      ])),
                                      _: 2,
                                      __: [24]
                                    }, 1032, ["to"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  target: "_blank",
                                  href: 
                      `https://api.whatsapp.com/send?phone=` +
                      _ctx.substrPhone(props.row.phone) +
                      `&`
                    
                                }, _cache[25] || (_cache[25] = [
                                  _createElementVNode("i", { class: "ph ph-whatsapp-logo lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Contacter ", -1)
                                ]), 8, _hoisted_11)
                              ]),
                              _createElementVNode("li", null, [
                                (_ctx.auth.can('NEW_CUSTOMERS') && props.row.statut==0)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "dropdown-item d-flex align-items-center",
                                      href: "javascript:void(0);",
                                      onClick: ($event: any) => (_ctx.archiveCustomer(props.row))
                                    }, _cache[26] || (_cache[26] = [
                                      _createElementVNode("i", { class: "ph ph-trash lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Supprimer ", -1)
                                    ]), 8, _hoisted_12))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(props.formattedRow[props.column.field]), 1))
        ]),
        _: 1
      }, 8, ["columns", "rows"]),
      _createVNode(_component_PaginatorContent, {
        pagination: _ctx.users,
        offset: 9,
        onPaginate: _ctx.fetchData
      }, null, 8, ["pagination", "onPaginate"])
    ])
  ]))
}